var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#fff",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M12.633 23.857V13.833h-3.43v10.024zm12.367 0V18.11c0-3.079-1.692-4.511-3.949-4.511-1.82 0-2.634.972-3.09 1.655v-1.42h-3.43c.045.94 0 10.024 0 10.024h3.43V18.26c0-.3.021-.599.112-.813.248-.599.812-1.219 1.76-1.219 1.24 0 1.737.92 1.737 2.267v5.363zM10.94 9C9.768 9 9 9.75 9 10.732c0 .962.743 1.732 1.895 1.732h.022c1.196 0 1.94-.77 1.94-1.732C12.837 9.75 12.114 9 10.942 9",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedininline;